import * as types from '../types/user';
import * as api from '../constants/';
import axios from 'axios';

function signIn() {
  return {
    type: types.SIGN_IN
  }
}

export function receiveUser(json) {
  const token = json.token;
  if (token) {
    localStorage.setItem('userToken', token);
  }

  return {
    type: types.USER_LOGIN,
    data: json.profile,
  }
}

function updatedUser(json) {
  return {
    type: types.USER_UPDATED,
    data: json,
  }
}

function createdUser() {
  return {
    type: types.USER_REGISTER,
  }
}

function removedUser(json) {
  localStorage.removeItem('userToken');

  return {
    type: types.USER_REMOVED,
    data: json,
  }
}

function profileUser(json) {
  return {
    type: types.USER_GET_PROFILE,
    data: json,
  }
}

export function loginUser(data) {
  return dispatch => {
    dispatch(signIn());
    return axios.post(api.AUTH_GET_TOKEN_URL, data)
      .then(response => {
        return dispatch(receiveUser(response.data))
      });
  }
}

export function registerUser(data) {
  return dispatch => {
    return axios.post(api.CUSTOMER_URL, data)
      .then(response => {
        dispatch(createdUser());
        dispatch(signIn());
        return dispatch(receiveUser(response.data));
      })
  }
}

export function updateUser(data) {
  return dispatch => {
    return axios.put(api.CUSTOMER_URL, data)
      .then(response => {
        return dispatch(updatedUser(response.data))
      })
  }
}

export function removeUser(data) {
  return dispatch => {
    return axios.delete(api.CUSTOMER_URL, {data: data})
      .then(response => {
        return dispatch(removedUser(response.data))
      })
  }
}

export function getProfileUser() {
  return dispatch => {
    return axios.get(api.CUSTOMER_URL)
      .then(response => {
        return dispatch(profileUser(response.data))
      })
  }
}

export function forgotPassword(data) {
  return dispatch => {
    dispatch({type: types.FORGOT_PASSWORD});
    return axios.post(api.CUSTOMER_RESET_PASSWORD_URL, data);
  }
}

export function resetPassword(data) {
  return dispatch => {
    const url = api.CUSTOMER_RESET_PASSWORD_URL + `${data.uid}/${data.token}/`;
    dispatch({type: types.RESET_PASSWORD});
    return axios.post(url, data);
  }
}

export function exitCustomer() {
  return dispatch => {
    dispatch({type: types.SIGN_OUT});
    localStorage.removeItem('userToken');
    return dispatch({
      type: types.USER_LOGOUT
    });
  }
}

export function openAuthModal() {
  return dispatch => {
    return dispatch({
      type: types.AUTH_OPEN_MODAL
    })
  }
}

export function closeAuthModal() {
  return dispatch => {
    return dispatch({
      type: types.AUTH_CLOSE_MODAL
    })
  }
}

export function signInAction() {
  return dispatch => {
    dispatch(signIn());
    return axios.get(api.AUTH_URL).then(response => {
      if (response.data) {
        return dispatch(receiveUser(response.data));
      }
    });
  }
}

export function subscribe(data) {
  return axios.post(api.SUBSCRIBE_URL, data)
    .then(response => {
      return response.data
    });
}


// WEBPACK FOOTER //
// ./src/actions/userActions.js